import type * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { labelCommonI18n } from '@_/i18n-common';
import { Button, DialogFooter, DialogHeader, DialogTitle } from '@_/ui';
import { i18nMessages } from '../../shared/i18nMessages.ts';

type FilterDialogContentProps = React.PropsWithChildren<{
  onReset?: () => void;
  onSubmit?: () => void;
  resetButtonDisabled?: boolean;
}>;

export function FilterDialogContent({
  children,
  onReset,
  onSubmit,
  resetButtonDisabled = false
}: FilterDialogContentProps) {
  return (
    <>
      <DialogHeader>
        <DialogTitle>
          <FormattedMessage {...labelCommonI18n.filters} />
        </DialogTitle>
      </DialogHeader>

      {children}

      <DialogFooter>
        <div className="flex justify-between">
          <div className="-ml-1.5">
            <Button disabled={resetButtonDisabled} onClick={onReset} variant="subtle">
              <FormattedMessage {...i18nMessages.clearAllFilters} />
            </Button>
          </div>

          <Button color="primary" onClick={onSubmit}>
            <FormattedMessage {...i18nMessages.showResults} />
          </Button>
        </div>
      </DialogFooter>
    </>
  );
}
